/*
 * @Date: 2023-02-15 09:30:50
 * @Description: 文件描述
 */
import Vue from 'vue';
import { login } from '@/api/login';
import { ACCESS_TOKEN } from '@/store/mutation-types';
import { welcome } from '@/utils/util';
import confirm from 'ant-design-vue/es/modal/confirm';
import MapAccount from '@/libs/MapAccount';
import CONFIG from '@/config';

const user = {
  state: {
    token: '',
    name: '',
    welcome: '',
    avatar: '',
    roles: [],
    info: {},
  },

  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token;
    },
    SET_NAME: (state, { name, welcome }) => {
      state.name = name;
      state.welcome = welcome;
    },
    SET_AVATAR: (state, avatar) => {
      state.avatar = avatar;
    },
    SET_ROLES: (state, roles) => {
      state.roles = roles;
    },
    SET_INFO: (state, info) => {
      state.info = info;
    },
  },

  actions: {
    // 登录
    Login({ commit }, userInfo) {
      return new Promise((resolve, reject) => {
        login(userInfo)
          .then((response) => {
            const { result } = response;
            Vue.ls.set(ACCESS_TOKEN, result.token, 7 * 24 * 60 * 60 * 1000);
            commit('SET_TOKEN', result.token);
            resolve();
          })
          .catch((error) => {
            reject(error);
          });
      });
    },

    setUserInfo({ commit }, userInfo) {
      commit('SET_INFO', userInfo);
      commit('SET_NAME', {
        name: userInfo?.nickname || userInfo?.staffname,
        welcome: welcome(),
      });
      commit('SET_AVATAR', userInfo?.head_img || CONFIG.System.defaultAvatar);
    },

    setUserRole({ commit }, roles) {
      commit('SET_ROLES', roles);
    },

    // 登出
    Logout() {
      MapAccount.logout((err) => {
        confirm({
          title: '注销发生错误！',
          content: err,
          okText: '重新加载',
          onOk: () => window.location.reload(),
        });
      });
    },
  },
};

export default user;
